import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2Helper} from "../utils/FITH2Helper";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import Spine = PIXI.spine.Spine;
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";

export class FITH2WinCapView extends PIXI.Container implements StageLayer {
    private _spines: Spine | null;
    private _spineContainer: PIXI.Sprite;
    private _button: ContinueButton;
    private _clickCallback: () => void;
    private _idleTimeLine: gsap.core.Timeline | null;
    private _countUp: BasicBitmapCountUp;

    private init(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 360);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;

        this._countUp = new BasicBitmapCountUp({
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 160,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 578);
        this._countUp.stopAt(0);
        this.visible = false;
        this.addChild(this._countUp);
        this.visible = false;

    }

    constructor() {
        super();
        this.name = "WinCapView";
        this.init();
    }

    private onButtonClick(playClickSound: boolean): void {
        const hideWinCapTL = gsap.timeline();
        hideWinCapTL.add(() => {
            FITH2SoundManager.playSound("capWinEnds");
            if (this._idleTimeLine) {
                if (this._idleTimeLine.isActive()) {
                    this._idleTimeLine.pause();
                    this._idleTimeLine.kill();
                }
                this._idleTimeLine = null;
            }
            this._button.enable(false);
        });

        hideWinCapTL.add([
            new SpineTween(this._spines!, 0, "Out"),
            FireInTheHole2.multiplier.update(1),
            () => {
                TweenLite.to(this, 0.2, {alpha: 0});
                FireInTheHole2.gameViewContainer.removeDimmer();
                TweenLite.to([this._button, this._countUp], 0.2, {alpha: 0});
                this._clickCallback();
                this._clickCallback = () => {
                };
            }
        ]);

        hideWinCapTL.add(() => {
            FITH2SoundManager.playAmbientLoop(1000);
            FITH2SoundManager.stopSoundEffect(FITH2SoundConfig.WIN_CAP_MUSIC);
            this.visible = false;
            this._spineContainer.removeChildren();
            this._spines!.destroy();
            this._spines = null;
        });
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 588);
            return;
        }
        this._button.position.set(360, Math.max(530, NolimitApplication.screenBounds.bottom - 210));
    }


    public show(callback: () => void, isReplay: boolean = false): gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {

            this._clickCallback = callback;
        });

        if (this._spines) {
            this._spines.destroy();
            this._spines = null;
        }

        this._spines = new Spine(FireInTheHole2.assetLoader.getSpineAsset("winCap"));
        this._countUp.alpha = 0;
        this.alpha = 0;
        tl.add(() => {
            FireInTheHole2.keypadPlugin.hide();
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.position.set(360, 578);
            this.visible = true;
            this.onResize();
            FITH2SoundManager.stopAmbientLoop();
            FireInTheHole2.gameViewContainer.addDimmer(false);
        }, 0);

        tl.add([
            TweenLite.to(this, 0.5, {alpha: 1}),
            () => {
                FITH2SoundManager.playSound(FITH2SoundConfig.WIN_CAP_START);
                this._spineContainer.addChild(this._spines!);
                FireInTheHole2.fsLeftView.hide();
                FireInTheHole2.multiplier.hide();
            },
            TweenLite.to(this._countUp, 0.2, {alpha: 1}),
            TweenLite.to(this._countUp.scale, 0.1, {x: 1, y: 1, ease: "sine.in"}),
            this._countUp.getCountAnimation(0, FireInTheHole2.model.gameData?.playedBetValue*FITH2GameConfig.WIN_CAP, 6.625),
            new SpineTween(this._spines!, 0, "In")
        ], 0);
        tl.add(() => {
                this._spines!.state.setAnimation(0, "Loop", true);
            });

        tl.add([
            TweenLite.to(this._countUp, 0.5, {alpha: 0}),
            () => {
                this.addChild(this._button);
                FITH2SoundManager.stopSoundEffect(FITH2SoundConfig.WIN_CAP_START);
                FITH2SoundManager.playWinCapMusic();
            },
        ], 6.625 + 1.5);
        tl.add(TweenLite.to(this._button, 0.5, {alpha: 1}));
        tl.add(() => {
                this._button.enable(true);
                FireInTheHole2.keypadPlugin.setWin(FireInTheHole2.model.gameData.accumulatedRoundWin, true, FITH2Helper.isWinBelowStake());
            });
        return tl;
    }
}